/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  ImageHelper,
  MediaType,
  RouteHelper,
  useCanWatchAuthContent,
} from "@nf/common";
import dynamic from "next/dynamic";
import { AppImage } from "components/AppImage/AppImage";

import Button from "components/Button";
import MoreInfoButton from "components/MoreInfoButton";
import { useSyncCompleted } from "hooks";
import { IListComponentItemProps } from "../../models";

const MediaAdditionalInfo = dynamic(
  () => import("components/Media/MediaAdditionalInfo")
);

const PlayButton = dynamic(() => import("components/PlayButton"));

const MyListButton = dynamic(() => import("components/MyListButton"));

const LinkWithLocale = dynamic(() => import("components/LinkWithLocale"));

import styles from "./ListComponentItemHighlight.module.scss";

type IListComponentItemHighlightProps = IListComponentItemProps;

export const ListComponentItemHighlight = ({
  media,
  isPlaceholder,
  index,
}: IListComponentItemHighlightProps) => {
  const { canWatch } = useCanWatchAuthContent(media);
  // const isAuthProcessCompleted = useSyncCompleted();

  if (!media || isPlaceholder) {
    return <div className={styles.item} />;
  }

  // const canAddToWatchlist =
  //   canWatch && media.MediaTypeCode !== MediaType.Collection;

  return (
    <div className={styles.item}>
      <AppImage
        src={ImageHelper.getHeroFrontpageUrl(media?.Images) || ""}
        alt={media.Title || ""}
        sizes="100vw"
        fill={true}
        isLCP={index === 0}
        className={styles.image}
      />

      <div className={styles.gradient} />

      <LinkWithLocale href={RouteHelper.goToDetails(media)}>
        <a className={styles.link} aria-label={media.Title} />
      </LinkWithLocale>

      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>{media?.Description}</h1>

          <div className={styles.metadata}>
            <Button variant="quaternary" href={RouteHelper.goToDetails(media)}>
              {media.Title}
            </Button>

            <MediaAdditionalInfo
              type={media.MediaTypeCode}
              year={media.Year}
              categories={media.Categories}
              className={styles.additionalDescription}
            />
          </div>
        </div>

        <div className={styles.actions}>
          <PlayButton media={media} />

          <MoreInfoButton media={media} />

          <MyListButton media={media} />
        </div>
      </div>
    </div>
  );
};
